module.exports = __webpack_public_path__ + "img/tuurro.t6.inside.d32342a2.png";